import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { ClientContext } from "@limitless/common/utils";
import { fetchGroupResponseTime } from "../../apis/group-response-time-api/GroupResponseTimeAPI";
const GroupResponseTimeContext = /*#__PURE__*/createContext({});
export const GroupResponseTimeContextProvider = ({
  children,
  delayNonEssentialCalls
}) => {
  const hook = useGroupResponseTime(delayNonEssentialCalls);
  const context = useMemo(() => ({
    ...hook
  }), [hook.timeSince]);
  return /*#__PURE__*/React.createElement(GroupResponseTimeContext.Provider, {
    value: context
  }, children);
};
export const useGroupResponseTimeContext = () => {
  return useContext(GroupResponseTimeContext);
};
GroupResponseTimeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  delayNonEssentialCalls: PropTypes.bool.isRequired
};
const useGroupResponseTime = delayNonEssentialCalls => {
  const [timeSince, setTimeSince] = React.useState({
    time: 0,
    loading: false
  });
  React.useEffect(() => {
    if (ClientContext._groupName && !delayNonEssentialCalls) {
      loadResponseTime();
    }
  }, []);
  const loadResponseTime = () => {
    setTimeSince({
      ...timeSince,
      loading: true
    });
    fetchGroupResponseTime(result => {
      setTimeSince({
        ...timeSince,
        loading: false,
        time: result.time
      });
    });
  };
  return {
    loadResponseTime,
    timeSince
  };
};